import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Input, Select, SelectItem,IndexPath, CheckBox } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image, View } from 'react-native';
import * as RootNavigation from '../../../../root.navigation.js';
import trackerApi from '../../../api/tracker';
import cities from '../../../city.js';
import ostan from '../../../province.js';
import { showMessage, hideMessage } from "react-native-flash-message";
import { useDispatch, useSelector} from 'react-redux';
import {loginNextStep, setPhoneNumber} from '../../../../store/actions/login'
const width = Dimensions.get('window').width;



const PlusIcon = (props) => (
  <Icon {...props} name='person' />
);


const PersonIcon = (props) => (
  <Icon {...props} name='person' />
);

const NoIcon = (props) => (
  <Icon {...props} name='person' />
);

const PhoneIcon = (props) => (
  <Icon {...props} name='smartphone-outline' />
);

const TelIcon = (props) => (
  <Icon {...props} name='phone' />
);

const AddressIcon = (props) => (
  <Icon {...props} name='compass-outline' />
);

const service = [
  'در بازکن صوتی تصویری',
  'در باز کن کنترلی'
]

export const RegisterForm = ({ navigation }) => {
  const [selectedIndex, setSelectedIndex] = useState(new IndexPath(0));
  const [serviceSelectedIndex, setServiceSelectedIndex] = useState(new IndexPath(0));
  const [ostanSelectedIndex, setOstanSelectedIndex] = useState(new IndexPath(0));

  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const [nationalNo, setNationalNo] = useState('');
  const [telephone, setTelephone] = useState('');
  const [homeAddress, setHomeAddress] = useState('');
  const [workAddress, setWorkAddress] = useState('');
  const [aldo, setAldo] = useState(true);
  const [comax, setComax] = useState(false);
  const [suzuki, setSuzuki] = useState(false);
  const [etc, setEtc] = useState(false);
  const phone = useSelector( state => state.login.phoneNumber);

  const [nameStatus, setNameStatus] = useState('');
  const [lastNameStatus, setLastNameStatus] = useState('');
  const [nationalNoStatus, setNationalNoStatus] = useState('');
  const [phoneStatus, setPhoneStatus] = useState('');
  const [telephoneStatus, setTelephoneStatus] = useState('');
  const [homeAddressStatus, setHomeAddressStatus] = useState('');
  const [workAddressStatus, setWorkAddressStatus] = useState('');

  const dispatch = useDispatch()
  const verifyInformation = async ()=>{
    if(name.length<3) setNameStatus('danger'); else setNameStatus('basic')
    if(lastName.length<3) setLastNameStatus('danger'); else setLastNameStatus('basic')
    if(nationalNo.length<10) setNationalNoStatus('danger'); else setNationalNoStatus('basic')
    if(phone.length<11 || !Number(phone)) setPhoneStatus('danger'); else setPhoneStatus('basic')
    if(telephone.length<7) setTelephoneStatus('danger'); else setTelephoneStatus('basic')
    if(homeAddress.length<4) setHomeAddressStatus('danger'); else setHomeAddressStatus('basic')
    if(workAddress.length<4) setWorkAddressStatus('danger'); else setWorkAddressStatus('basic')
    if( name.length>2 && lastName.length>2 && nationalNo.length==10 && phone.length==11 && telephone.length>6 && homeAddress.length>3 && workAddress.length>3){
      const brands = [];
      if(aldo) brands.push('آلدو')
      if(comax) brands.push('کوماکس')
      if(suzuki) brands.push('سوزوکی')
      if(etc) brands.push('سایر')
      const newUser = {
        firstname:      name,
        lastname:       lastName,
        phone:          phone,
        telephone:      telephone,
        national_no:    nationalNo,
        province:       ostan[ostanSelectedIndex.row],
        city:           cities[ostanSelectedIndex.row][selectedIndex-1],
        home_address:   homeAddress,
        work_address:   workAddress,
        account_type:   'agent',
        // service_type:   (serviceSelectedIndex.length>1? `[${service[serviceSelectedIndex[0].row]},${service[serviceSelectedIndex[1].row]}]`: [service[serviceSelectedIndex[0].row]]),
        service_type:   `{"brands":[${
        brands.map((item) => {
          return (`"${item}"`)
        })
      }], "type":["در باز کن کنترلی"]}`,
        verified:       0,
        enabled:        0,
      }
      console.log(serviceSelectedIndex);
      const response = await trackerApi.post('/addagent', newUser);
      if(response.data.status){
        showMessage({
          message: response.data.message,
          type: "success",
        })
        RootNavigation.navigate('Upload');
      }
      else{
        showMessage({
          message: response.data.error,
          type: "danger",
        })
      }
    }
  }

  return (

      <Layout style={styles.container} level='3' >
      <SafeAreaView>
      <ScrollView>
      <Layout level='3' style={{flex:1,justifyContent:'flex-start', alignItems:'center', width:width-50, marginHorizontal:15}}>
        <Image
          style={{width:width*0.4, height: width*0.4/1.43, marginVertical:10}}
          source={require('../../../../assets/form.png')} />
        <Text category='h6' status='primary'>فرم ثبت نام</Text>


          <Input
            style={{flex:1,margin:8, width: width-30}}
            label={evaProps => <Text {...evaProps}>نام</Text>}
            placeholder ='نام'
            value={name}
            accessoryLeft={PersonIcon}
            onChangeText = {newValue =>{ setName(newValue)}}
            status = {nameStatus}
            key={1}
            />
            <Input
              style={{flex:1, margin:8, width: width-30}}
              label={evaProps => <Text {...evaProps}>نام خانوادگی</Text>}
              placeholder ='نام خانوادگی'
              value={lastName}
              accessoryLeft={PersonIcon}
              onChangeText = {newValue =>{ setLastName(newValue)}}
              status = {lastNameStatus}
              key={2}

              />
          <Input
            style={{flex:1, margin:8, width: width-30}}
            label={evaProps => <Text {...evaProps}>کد ملی</Text>}
            placeholder ='کد ملی ده رقمی'
            value={nationalNo}
            accessoryLeft={NoIcon}
            keyboardType = 'numeric'
            maxLength={10}
            onChangeText = {newValue =>{ setNationalNo(newValue)}}
            status = { nationalNoStatus}
            key={3}
            />
            <Input
              style={{flex:1, margin:8, width: width-30}}
              label={evaProps => <Text {...evaProps}>شماره همراه (با اعداد لاتین وارد نمایید.)</Text>}
              placeholder ='شماره موبایل خود را وارد نمایید'
              value={phone}
              keyboardType = 'numeric'
              maxLength={11}
              accessoryLeft={PhoneIcon}
              onChangeText = {newValue =>{dispatch(setPhoneNumber(newValue))}}
              status = { phoneStatus}
              key={4}
              />

              <Input
                style={{flex:1, margin:8, width: width-30}}
                label={evaProps => <Text {...evaProps}>شماره تلفن ثابت</Text>}
                placeholder ='شماره ثابت محل کار و یا منزل'
                value={telephone}
                accessoryLeft={TelIcon}
                keyboardType = 'numeric'
                maxLength={11}
                onChangeText = {newValue =>{ setTelephone(newValue)}}
                status = {telephoneStatus}
                key={5}
                />

                  <Select
                    style={{flex:1, margin:8, width:width-60}}
                    label={evaProps => <Text {...evaProps}>استان</Text>}
                    selectedIndex={ostanSelectedIndex}
                    value = {ostan[ostanSelectedIndex.row]}
                    onSelect={index => setOstanSelectedIndex(index)}>
                    {
                      ostan.map((data, index)=>{
                        return (
                          <SelectItem title={data} key={index} />
                        )
                      })
                    }
                  </Select>

                  <Select
                    style={{flex:1, margin:8, width:width-60}}
                    label={evaProps => <Text {...evaProps}>شهرستان</Text>}
                    selectedIndex={selectedIndex}
                    value = {cities[ostanSelectedIndex.row][selectedIndex-1]}

                    onSelect={index => setSelectedIndex(index)}>
                    {
                      cities[ostanSelectedIndex.row].map((data)=>{
                        return (
                          <SelectItem title={data} />
                        )
                      })
                    }

                  </Select>

                  <Input
                    style={{flex:1, margin:8, width: width-30}}
                    label={evaProps => <Text {...evaProps}>آدرس محل سکونت</Text>}
                    placeholder ='آدرس را کامل وارد نمایید'
                    value={homeAddress}
                    accessoryLeft={AddressIcon}
                    multiline={true}
                    onChangeText = {newValue =>{ setHomeAddress(newValue)}}
                    status = { homeAddressStatus}
                    key={6}
                    />

                    <Input
                      style={{flex:1, margin:8, width: width-30}}
                      label={evaProps => <Text {...evaProps}>آدرس محل کار</Text>}
                      placeholder ='آدرس را کامل وارد نمایید'
                      value={workAddress}
                      accessoryLeft={AddressIcon}
                      multiline={true}
                      onChangeText = {newValue =>{ setWorkAddress(newValue)}}
                      status = {workAddressStatus}
                      key={7}
                      />

                      <Select
                        multiSelect={true}

                        style={{flex:1, margin:8, width:width-60}}
                        label={evaProps => <Text {...evaProps}>نوع خدمات</Text>}
                        selectedIndex={serviceSelectedIndex}
                        value = {(serviceSelectedIndex.length>1 ? `${service[serviceSelectedIndex[0].row]} ,${service[serviceSelectedIndex[1].row]}`: (serviceSelectedIndex[0] ? service[serviceSelectedIndex[0].row] : null))}
                        onSelect={index => setServiceSelectedIndex(index)}>
                        <SelectItem title='در بازکن صوتی تصویری'/>
                        <SelectItem title='دربازکن کنترلی'/>
                      </Select>
                      <View style={{alignItems:'flex-start', width:width-60, marginTop:10}}>
                      <Text appearance='hint' category='c2'> مدل‌ دستگاه‌های تحت پشتیبانی </Text>
                      <CheckBox
                        style={{ marginHorizontal:15, marginTop:10}}
                        checked={aldo}
                        onChange={nextChecked => setAldo(nextChecked)}>
                        <Text>
                          آلدو
                        </Text>
                      </CheckBox>
                      <CheckBox
                        style={{ marginHorizontal:15, marginTop:10}}
                        checked={suzuki}
                        onChange={nextChecked => setSuzuki(nextChecked)}>
                        <Text>
                          سوزوکی
                        </Text>
                      </CheckBox>
                      <CheckBox
                        style={{ marginHorizontal:15, marginTop:10}}
                        checked={comax}
                        onChange={nextChecked => setComax(nextChecked)}>
                        <Text>
                          کوماکس
                        </Text>
                      </CheckBox>
                      <CheckBox
                        style={{ marginHorizontal:15, marginTop:10}}
                        checked={etc}
                        onChange={nextChecked => setEtc(nextChecked)}>
                        <Text>
                          سایر
                        </Text>
                      </CheckBox>
                      </View>
                      <Button
                      disabled={!(comax || aldo || etc || suzuki)}
                      style={{width:width-60,borderRadius:10, marginVertical:30}}
                      onPress = {verifyInformation}
                      >تایید اطلاعات </Button>

      </Layout>
      </ScrollView>
      </SafeAreaView>


      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',
    width


  },
});
